'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onFileProgress = exports.handleFieldSubmit = exports.isWatchedEntity = undefined;

var _pick2 = require('lodash/fp/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _get2 = require('lodash/fp/get');

var _get3 = _interopRequireDefault(_get2);

var _stubTrue2 = require('lodash/stubTrue');

var _stubTrue3 = _interopRequireDefault(_stubTrue2);

var _partial2 = require('lodash/partial');

var _partial3 = _interopRequireDefault(_partial2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _cond2 = require('lodash/cond');

var _cond3 = _interopRequireDefault(_cond2);

exports.handleAuth = handleAuth;
exports.handleLogout = handleLogout;
exports.handleProfileField = handleProfileField;
exports.sendPayload = sendPayload;
exports.handleTriplePut = handleTriplePut;
exports.handleFileUpload = handleFileUpload;

var _capeLodash = require('cape-lodash');

var _reduxField = require('redux-field');

var _capeSelect = require('cape-select');

var _actions = require('./actions');

var _handler = require('./handler');

var _util = require('./util');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // import { selectGraph } from 'redux-graph'


function handleAuth(_ref) {
  var firebase = _ref.firebase,
      store = _ref.store;
  var auth = firebase.auth,
      googleAuth = firebase.googleAuth; // console.log(credential)

  return auth.signInWithPopup(googleAuth).then((0, _flow3.default)((0, _get3.default)('user'), (0, _handler.loginUser)(firebase, store)));
}

function handleLogout(_ref2) {
  var auth = _ref2.firebase.auth,
      action = _ref2.action,
      next = _ref2.next;
  return auth.signOut().then(next(action));
}

function handleProfileField(_ref3) {
  var firebase = _ref3.firebase,
      _ref3$store = _ref3.store,
      dispatch = _ref3$store.dispatch,
      getState = _ref3$store.getState,
      action = _ref3.action,
      next = _ref3.next;
  next(action);
  var state = getState();
  var entityPath = action.meta.prefix; // const entity = flow(selectGraph, get(entityPath))(state)

  var entity = {
    type: entityPath[0],
    id: entityPath[1]
  };
  var fieldId = (0, _reduxField.fieldValue)(entityPath, 'id')(state);
  var update = (0, _capeLodash.set)(entity, fieldId, action.payload);
  (0, _util.entityUpdate)(firebase, update).then(function () {
    return dispatch((0, _reduxField.clear)(entityPath));
  });
}

var isWatchedEntity = exports.isWatchedEntity = (0, _capeSelect.simpleSelector)((0, _get3.default)('action.meta.prefix[0]'), (0, _get3.default)('entityIds'), _get3.default);
var handleFieldSubmit = exports.handleFieldSubmit = (0, _cond3.default)([[isWatchedEntity, handleProfileField], [_stubTrue3.default, _util.nextAction]]);

function sendPayload(handler) {
  return function (_ref4) {
    var action = _ref4.action,
        firebase = _ref4.firebase,
        next = _ref4.next;
    next(action);
    return handler(firebase, action.payload);
  };
}

function handleTriplePut(_ref5) {
  var firebase = _ref5.firebase,
      action = _ref5.action,
      next = _ref5.next;
  next(action);
  return (0, _util.triplePut)(firebase, action);
} // Update entity progress.


var onFileProgress = exports.onFileProgress = function onFileProgress(dispatch, entity) {
  return (0, _flow3.default)((0, _pick3.default)(['bytesTransferred']), (0, _partial3.default)(_actions.updateEntityFields, entity), dispatch);
};

function handleFileUpload(_ref6) {
  var firebase = _ref6.firebase,
      action = _ref6.action,
      store = _ref6.store,
      next = _ref6.next;
  var _action$payload = action.payload,
      file = _action$payload.file,
      entity = _action$payload.entity;
  var uploadTask = firebase.storage.child(entity.fileName).put(file);
  next(action);
  return new Promise(function (accept, reject) {
    uploadTask.on('state_changed', onFileProgress(store.dispatch, entity), reject, (0, _partial3.default)(accept, store));
  });
}